"use client";
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Icon } from '../../Icon/Icon.web.js';

var _excluded = ["color", "size"];
var IconHelp = function IconHelp(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === undefined ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    sizeProp = _ref$size === undefined ? '48px' : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  var size = sizeProp;
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
    fill: "none",
    viewBox: "0 0 48 48",
    width: size,
    height: size
  }, /*#__PURE__*/React.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    d: "M40.27 9H21.73A4.73 4.73 0 0 0 17 13.692v9.538a4.72 4.72 0 0 0 1.367 3.367l.182.174A4.73 4.73 0 0 0 21.73 28h8.851l4.14 4.207L38.849 28h1.421A4.73 4.73 0 0 0 45 23.232V13.7A4.73 4.73 0 0 0 40.27 9m-18.54 2h18.54A2.73 2.73 0 0 1 43 13.708v9.532A2.73 2.73 0 0 1 40.27 26h-2.26l-3.291 3.353-3.3-3.353H21.73A2.73 2.73 0 0 1 19 23.24V13.7a2.73 2.73 0 0 1 2.73-2.7m14.99 7.12a2.41 2.41 0 0 0 .91-1.87A2.18 2.18 0 0 0 35.24 14a2.34 2.34 0 0 0-2.53 2.48h1.19a1.28 1.28 0 0 1 1.34-1.37 1.06 1.06 0 0 1 1.19 1.1 1.7 1.7 0 0 1-.61 1.2q-.14.142-.29.28c-.51.48-1.03.97-1.03 1.96V20h1.14v-.21c0-.733.41-1.087.861-1.478q.11-.094.219-.192m-.94 3.03h-1.43v1.43h1.43zM15 22v2H8.286a2.33 2.33 0 0 0-1.607.634 2.12 2.12 0 0 0-.668 1.327L6 26.15v7.614c.014.572.26 1.114.715 1.537.376.384.872.625 1.383.685L8.29 36h2.045l2.874 2.787.947-.917 1.94-1.87h8.587a2.37 2.37 0 0 0 1.638-.734 2.12 2.12 0 0 0 .668-1.327L27 33.75V30h2v3.763a4.1 4.1 0 0 1-1.13 2.785l-.155.151a4.34 4.34 0 0 1-2.76 1.288L24.71 38l-7.807-.001-1.357 1.309-2.336 2.265-3.686-3.574H8.263a4.3 4.3 0 0 1-2.777-1.105l-.165-.16a4.13 4.13 0 0 1-1.308-2.702L4 33.79v-7.653a4.12 4.12 0 0 1 1.316-2.967 4.33 4.33 0 0 1 2.739-1.165L8.29 22zm3 6.97v1h-8v-1zm6 4v-1H10v1z",
    clipRule: "evenodd"
  })));
};

export { IconHelp, IconHelp as default };
